import React, { useState, useEffect } from 'react';
import OtpInput from '../otp/otp';
import { OtpResponse } from '../../api/login';

interface OtpFormProps {
    mobileNumber: string;
    otpLoader: boolean;
    otpError: string;
    otpVerified: boolean;
    resendCountDown: number;
    otp: OtpResponse;
    verifyOtp: (otp: string) => void;
    resendOtp: () => void;
    resetNumber: () => void;
}

const OtpForm: React.FC<OtpFormProps> = ({
    mobileNumber,
    otpError,
    otpLoader,
    otpVerified,
    resendCountDown,
    otp,
    verifyOtp,
    resendOtp,
    resetNumber,
}) => {
    const [reset, setReset] = useState(false);
    const [shouldShowError, setShouldShowError] = useState(false);

    useEffect(() => {
        if (!otpLoader) {
            setShouldShowError(!!otpError);
        }
    }, [otpLoader]);

    const resetErrorState = () => {
        setShouldShowError(false);
    };

    const resetOtp = () => {
        setReset(true);
        resendOtp();
    };

    const error = !otpVerified && !!otpError;
    return (
        <>
            <div className="flex flex-col items-center mt-32.6 space-y-16">
                <div className="flex flex-col items-center bg-actionPrimary-inverted">
                    <p className="leading-9 font-400 text-23 text-neutral-2 h-36 ">Verify OTP</p>
                    {otp.triggered ? (
                        <p className="flex flex-row self-end justify-center flex-wrap mt-8 text-16 text-neutral-4">
                            An OTP has been sent to
                            <span className="text-actionPrimary">
                                &nbsp; <button onClick={resetNumber}> {mobileNumber}</button>{' '}
                            </span>
                        </p>
                    ) : null}
                </div>
                <OtpInput
                    verifyOtp={verifyOtp}
                    error={shouldShowError}
                    reset={reset}
                    otpLoader={otpLoader}
                    // disabled={!otp.triggered}
                    disabled={false}
                    resetError={resetErrorState}
                />
                {!otp.triggered ? (
                    <p className="text-13 text-neutral-4">
                        <span className="text-status-warning">{otp.message}</span>
                    </p>
                ) : error ? (
                    <p className="text-13 text-neutral-4">
                        <span className="text-status-warning">Wrong OTP &nbsp;</span>
                        <button onClick={resetOtp} disabled={resendCountDown > -1}>
                            <span className="text-actionPrimary">Resend OTP</span>
                        </button>
                    </p>
                ) : resendCountDown > 0 ? (
                    <p className="text-13 text-neutral-4">Resend OTP in {resendCountDown} Sec.</p>
                ) : (
                    <p className="text-13 text-neutral-4">
                        <span>Didn't get code? &nbsp;</span>
                        <button onClick={resetOtp}>
                            <span className="text-actionPrimary">Resend OTP</span>
                        </button>
                    </p>
                )}
            </div>
            <button
                className="items-center justify-center primary-btn btn w-full py-12"
                disabled={otpLoader || !otpVerified || error}
                type="button"
            >
                <span className="text-center">Login</span>
                {otpLoader ? (
                    <span className="pl-8">
                        <svg
                            width="24"
                            height="24"
                            version="1.1"
                            id="L4"
                            xmlns="http://www.w3.org/2000/svg"
                            x="0px"
                            y="0px"
                            viewBox="0 0 100 100"
                            enableBackground="new 0 0 0 0"
                        >
                            <circle fill="#003BA8" stroke="none" cx="6" cy="50" r="6">
                                <animate
                                    attributeName="opacity"
                                    dur="1s"
                                    values="0;1;0"
                                    repeatCount="indefinite"
                                    begin="0.1"
                                ></animate>
                            </circle>
                            <circle fill="#003BA8" stroke="none" cx="26" cy="50" r="6">
                                <animate
                                    attributeName="opacity"
                                    dur="1s"
                                    values="0;1;0"
                                    repeatCount="indefinite"
                                    begin="0.2"
                                ></animate>
                            </circle>
                            <circle fill="#003BA8" stroke="none" cx="46" cy="50" r="6">
                                <animate
                                    attributeName="opacity"
                                    dur="1s"
                                    values="0;1;0"
                                    repeatCount="indefinite"
                                    begin="0.3"
                                ></animate>
                            </circle>
                        </svg>
                    </span>
                ) : null}
            </button>
        </>
    );
};

export default OtpForm;
